import { render, staticRenderFns } from "./OwnerListTemplate.vue?vue&type=template&id=2cf98c0c"
import script from "./OwnerListTemplate.vue?vue&type=script&lang=js"
export * from "./OwnerListTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports